import { IPerformer } from '@interfaces/performer';
import {
  useSelector
} from 'react-redux';
import { Button, message } from 'antd';
import Router, { useRouter } from 'next/router';
import { IUser } from '@interfaces/user';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { EuroOutlined, UserAddOutlined } from '@ant-design/icons';
import style from './subscribe-buttons.module.scss';

const ConfirmSubscriptionPerformerForm = dynamic(() => import('@components/performer/common/confirm-subscription'), { ssr: false });
const ModalTip = dynamic(() => import('@components/performer/tip/modal-tip'), { ssr: false });

type Props = {
  performer: IPerformer;
};

function SubscribeButtons({
  performer
}: Props) {
  const user: IUser = useSelector((state: any) => state.user.current);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showTipModal, setShowTipModal] = useState(false);
  const router = useRouter();

  const handleSubscribe = () => {
    if (!user._id) {
      message.error('Please log in or register!');
      Router.push(`/auth/login?redirect=${encodeURIComponent(router.asPath)}`);
      return;
    }
    setShowConfirm(true);
  };

  const handleTip = () => {
    if (!user._id) {
      message.error('Please log in or register!');
      Router.push(`/auth/login?redirect=${encodeURIComponent(router.asPath)}`);
      return;
    }
    setShowTipModal(true);
  };

  // Check if user is subscribed
  const isSubscribed = performer?.isSubscribed;

  return (
    <>
      <div className={style['subscription-bl']}>
        {!isSubscribed && (
          <>
            <Button
              type="primary"
              className={style['sub-btn']}
              disabled={!user._id}
              icon={<UserAddOutlined />}
              onClick={handleSubscribe}
            >
              TO FOLLOW
            </Button>
          </>
        )}
        <Button
          type="primary"
          className={style['sub-btn']}
          disabled={!user._id || user.isPerformer}
          onClick={handleTip}
          icon={<EuroOutlined />}
        >
          SUPPORT CREATOR
        </Button>
      </div>
      {showConfirm && (
        <ConfirmSubscriptionPerformerForm
          performer={performer}
          subscriptionType="free"
          onClose={() => setShowConfirm(false)}
        />
      )}
      {showTipModal && (
        <ModalTip
          performer={performer}
          open={showTipModal}
          onClose={() => setShowTipModal(false)}
        />
      )}
    </>
  );
}

export default SubscribeButtons;
